var sliderInput = {
    base: {
        display: "flex",
        justifyContent: "stretch",
        height: "var(--handle-height)",
        alignItems: "center",
        "--value-margin": "1.5rem",
        "&:not([data-display-value='none'])": {
            mt: "var(--value-margin)",
        },
        "[data-reach-slider-input]": {
            width: "100%",
        },
        '[data-reach-slider-input][data-orientation="horizontal"]': {
            height: "var(--track-height)",
        },
        '[data-reach-slider-input][data-orientation="vertical"]': {
            width: "0.5rem",
            /* the height is somewhat arbitrary but necessary for vertical sliders for
            basic functionality */
            height: "250px",
            maxHeight: "100%",
        },
        "[data-reach-slider-input][data-disabled]": {
            opacity: "0.5",
            pointerEvents: "none",
        },
        "--colors-shadow": "primary.20",
    },
    variantOrder: ["size"],
    variants: {
        size: {
            sm: {
                "--handle-height": "1.5rem",
                "--track-height": "4px",
                "--marker-height": "2px",
                "--font-size": "0.875rem",
                "--label-top-height": "-1.35rem",
                "--track-padding": "0.75rem",
            },
            md: {
                "--handle-height": "1.75rem",
                "--track-height": "6px",
                "--marker-height": "4px",
                "--font-size": "1.0rem",
                "--label-top-height": "-1.6rem",
                "--track-padding": "0.9rem",
            },
            lg: {
                "--handle-height": "2rem",
                "--track-height": "8px",
                "--marker-height": "6px",
                "--font-size": "1.25rem",
                "--label-top-height": "-1.9rem",
                "--track-padding": "1rem",
            },
        },
    },
};
var sliderTrackContainer = {
    base: {
        px: "var(--track-padding)",
        height: "100%",
    },
};
var sliderTrack = {
    base: {
        px: "var(--track-padding)",
        height: "100%",
        "[data-reach-slider-track]": {
            position: "relative",
            borderRadius: "0.25rem",
            backgroundColor: "black.10",
        },
        '[data-reach-slider-track][data-orientation="horizontal"]': {
            width: "100%",
            height: "inherit",
        },
        '[data-reach-slider-track][data-orientation="vertical"]': {
            width: "inherit",
            height: "100%",
        },
        /* This pseudo element provides an invisible area that increases the touch
            target size of the track */
        "[data-reach-slider-track]::before": {
            content: '""',
            position: "absolute",
        },
        '[data-reach-slider-track][data-orientation="horizontal"]::before': {
            width: "100%",
            height: "1.5rem",
            top: "calc(-0.5rem - 1px)",
            left: "0",
        },
        '[data-reach-slider-track][data-orientation="vertical"]::before': {
            width: "1.5rem",
            height: "100%",
            top: "0",
            left: "calc(-0.5rem - 1px)",
        },
        ":focus-within": {
            "[data-reach-slider-marker][data-display-markers='hover']": {
                opacity: 1,
                transitionDuration: 4,
                transitionProperty: "opacity",
            },
            "[data-reach-slider-handle-icon]": {
                display: "block",
                boxShadow: 0,
                transitionDuration: 4,
                transitionProperty: "box-shadow",
            },
            "[data-reach-slider-handle][data-display-value='hover']:after": {
                opacity: 1,
                transitionDuration: 4,
                transitionProperty: "opacity",
            },
        },
        ":hover": {
            "[data-reach-slider-marker][data-display-markers='hover']": {
                display: "block",
                opacity: 1,
                transitionDuration: 4,
                transitionProperty: "opacity",
            },
            "[data-reach-slider-handle][data-display-value='hover']:after": {
                opacity: 1,
                transitionDuration: 4,
                transitionProperty: "opacity",
            },
        },
    },
};
var sliderRange = {
    base: {
        "&[data-reach-slider-range]": {
            borderRadius: "inherit",
            backgroundColor: "primary.100",
            position: "absolute",
        },
        '&[data-reach-slider-range][data-orientation="horizontal"]': {
            height: "100%",
        },
        '&[data-reach-slider-range][data-orientation="vertical"]': {
            width: "100%",
        },
    },
};
var sliderRangeLabel = {
    base: {
        justifyContent: "space-between",
        font: "body",
        fontSize: "var(--font-size)",
    },
};
var sliderMarker = {
    base: {
        "&[data-reach-slider-marker]": {
            backgroundColor: "black.5",
            transformOrigin: "center",
            zIndex: 1,
            opacity: 0,
            transitionDuration: 4,
            transitionProperty: "opacity",
        },
        "&[data-reach-slider-marker][data-display-markers='always']": {
            opacity: 1,
        },
        '&[data-reach-slider-marker][data-orientation="horizontal"]': {
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: "2px",
            height: "var(--marker-height)",
            borderRadius: "6px",
        },
        '&[data-reach-slider-marker][data-orientation="vertical"]': {
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "0.75rem",
            height: "3px",
        },
        '&[data-reach-slider-marker][data-state="at-value"], [data-reach-slider-marker][data-state="under-value"]': {
        /* */
        },
    },
};
var sliderHandle = {
    base: {
        "&[data-reach-slider-handle]": {
            borderRadius: "2rem",
            zIndex: 2,
            transformOrigin: "center",
            cursor: "pointer",
            ":after": {
                fontSize: "var(--font-size)",
                color: "black.100",
                content: "attr(data-placeholder)",
                display: "flex",
                justifyContent: "center",
                position: "absolute",
                width: "100%",
                top: "var(--label-top-height)",
                opacity: 0,
                transitionDuration: 4,
                transitionProperty: "opacity",
            },
            "&[data-reach-slider-handle][data-display-value='always']": {
                ":after": {
                    opacity: 1,
                },
            },
        },
        "[data-reach-slider-handle-icon]": {
            fontSize: "var(--handle-height)",
            borderRadius: "var(--handle-height)",
            backgroundColor: "white",
            display: "block",
            alignItems: "center",
            justifyContent: "center",
            transitionDuration: 4,
            transitionProperty: "box-shadow",
        },
        "&[data-reach-slider-handle][aria-orientation='horizontal']": {
            top: "50%",
            transform: "translateY(-50%)",
        },
        "&[data-reach-slider-handle][aria-orientation='horizontal']:focus": {
            transform: "translateY(-50%)",
        },
        "&[data-reach-slider-handle][aria-orientation='vertical']": {
            left: "50%",
            transform: "translateX(-50%)",
        },
        "[data-reach-slider-handle-label]": {
            width: "2rem",
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            color: "black.100",
        },
        font: "body",
        color: "primary.100",
    },
};

export { sliderHandle, sliderInput, sliderMarker, sliderRange, sliderRangeLabel, sliderTrack, sliderTrackContainer };
//# sourceMappingURL=slider.js.map
